/* Anemoia — product page behaviour.
   1. Shipping estimator: pick a country, get the cost in the visitor's own
      currency plus a delivery window.
   2. Description collapse.
   3. Relocation of two elements that other scripts position, so Liquid cannot:
        .aask     — Ask-about-this-piece chips, injected after .product-form
        .avr-slot — reviews, moved into the media column at tablet+
      "Fits best to" goes immediately above the chips; Material Note under reviews. */
(function () {
  'use strict';

  var EU = 'AT BE BG HR CZ DK EE FI FR DE HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' ');
  /* Rates and transit windows mirror the Shopify delivery profile exactly.
     Transit is business days from dispatch; preparation adds a further 2-4.
     If rates change in admin, change them here AND in snippets/anemoia-ship-line.liquid. */
  function zone(c) {
    if (c === 'GR' || c === 'CY') return { fee: 0,  free: 0,   lo: 3, hi: 5  };
    if (EU.indexOf(c) > -1)       return { fee: 10, free: 200, lo: 7, hi: 14 };
    if (c === 'GB')               return { fee: 12, free: 250, lo: 9, hi: 18 };
    if (c === 'US' || c === 'CA') return { fee: 18, free: 250, lo: 7, hi: 14 };
    if (c === 'AU' || c === 'NZ') return { fee: 15, free: 250, lo: 9, hi: 18 };
    return { fee: 18, free: 250, lo: 9, hi: 18 };
  }
  /* Import duty differs by destination and the difference is material, so the row says which
     case applies rather than one blanket sentence. Wording is deliberately conservative: it
     states what is prepaid, and puts everything else on the buyer without promising an outcome.
     Kept beside zone() because both are destination logic and must not drift apart.
     GR and CY are EU members but are handled as Domestic in zone(), so they are named here. */
  var DUTY_US  = 'Prepaid before dispatch, so it is not collected on delivery. That covers the import duty alone — any additional costs, taxes or charges, including state sales and use tax, are not included in the item price or the shipping cost and remain the buyer\'s responsibility. <a href="/blogs/the-good-old/customs-import-duty-europe-to-usa">What US buyers should know</a>';
  var DUTY_EU  = 'Your order moves within the EU customs union, so there are no import duties or customs formalities on arrival.';
  var DUTY_ROW = 'Any import duty, tax or charge applied on arrival is set by the destination country. It is not included in the item price or the shipping cost and remains the buyer\'s responsibility. Your local customs office can confirm what applies.';
  function dutyText(c) {
    if (c === 'US') return DUTY_US;
    if (c === 'GR' || c === 'CY' || EU.indexOf(c) > -1) return DUTY_EU;
    return DUTY_ROW;
  }

  function addBiz(d, n) {
    var x = new Date(d.getTime()), a = 0;
    while (a < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) a++; }
    return x;
  }
  var MON = 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ');
  function fmtRange(a, b) {
    if (a.getMonth() === b.getMonth()) return a.getDate() + '–' + b.getDate() + ' ' + MON[b.getMonth()];
    return a.getDate() + ' ' + MON[a.getMonth()] + ' – ' + b.getDate() + ' ' + MON[b.getMonth()];
  }

  function estimator() {
    var root = document.querySelector('[data-av-est]');
    if (!root || root.dataset.avReady) return;
    root.dataset.avReady = '1';
    var sel  = root.querySelector('[data-av-country]'),
        cost = root.querySelector('[data-av-cost]'),
        eta  = root.querySelector('[data-av-eta]'),
        duty = root.querySelector('[data-av-duty]');
    if (!sel || !cost || !eta) return;

    var cur  = root.getAttribute('data-cur') || 'EUR';
    var pres = parseInt(root.getAttribute('data-price') || '0', 10) / 100;
    var eur  = (cur === 'EUR') ? pres : null;
    var rate = (cur === 'EUR') ? 1 : null;

    /* Shipping rates are set in euro, but Markets shows the visitor local money.
       Rather than invent an exchange rate, derive Shopify's own: the same garment
       priced in euro (asked for via the Greek market) against its presented price. */
    function money(eurAmount) {
      if (rate === null || cur === 'EUR') return '€' + eurAmount;
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency', currency: cur, maximumFractionDigits: 0
        }).format(eurAmount * rate);
      } catch (e) { return '€' + eurAmount; }
    }

    function render() {
      var z = zone(sel.value);
      var onUs = z.fee === 0 || (eur !== null && z.free > 0 && eur >= z.free);
      if (onUs)            cost.innerHTML = '<b>On us</b>';
      else if (z.free > 0) cost.innerHTML = '<b>' + money(z.fee) + '</b> · on us over ' + money(z.free);
      else                 cost.innerHTML = '<b>' + money(z.fee) + '</b>';
      if (duty) duty.innerHTML = dutyText(sel.value);
      var now = new Date();
      eta.textContent = 'between ' + fmtRange(addBiz(now, 2 + z.lo), addBiz(now, 4 + z.hi));
      try { localStorage.setItem('av_ship_country', sel.value); } catch (e) {}
    }

    if (eur === null && window.fetch) {
      var pu = root.getAttribute('data-purl');
      if (pu) {
        fetch(pu + '.js?country=GR')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.price) {
              eur = d.price / 100;
              if (eur > 0) rate = pres / eur;
              render();
            }
          })
          .catch(function () {});
      }
    }
    try {
      var saved = localStorage.getItem('av_ship_country');
      if (saved) for (var i = 0; i < sel.options.length; i++)
        if (sel.options[i].value === saved) { sel.selectedIndex = i; break; }
    } catch (e) {}
    sel.addEventListener('change', render);
    render();
  }

  function collapse() {
    var w = document.querySelector('[data-av-desc]');
    if (!w || w.dataset.avReady) return;
    var inner = w.querySelector('[data-av-desc-inner]'), btn = w.querySelector('[data-av-desc-btn]');
    if (!inner || !btn) return;
    w.dataset.avReady = '1';
    var CAP = 132, opened = false, lastW = window.innerWidth;

    function measure() {
      /* Once the reader has opened it, never close it again. On a phone the
         address bar hides on scroll, which fires resize — re-measuring there
         was snapping the description shut mid-read while the button still
         said "Show less". */
      if (opened) return;
      if (inner.scrollHeight > CAP + 40) { w.classList.add('is-collapsed'); btn.hidden = false; }
      else { w.classList.remove('is-collapsed'); btn.hidden = true; }
    }
    btn.addEventListener('click', function () {
      opened = w.classList.toggle('is-collapsed') === false;
      btn.setAttribute('aria-expanded', opened ? 'true' : 'false');
      btn.textContent = opened ? 'Show less' : 'Learn more about this item';
      if (!opened) w.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
    measure();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    /* Width-only: ignore the height changes a scrolling mobile browser produces. */
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      measure();
    });
  }

  function place() {
    var fit = document.querySelector('[data-av-fit]'), aask = document.querySelector('.aask');
    if (fit && aask && fit.nextElementSibling !== aask) aask.parentNode.insertBefore(fit, aask);
    var story = document.querySelector('.av-storylink'), avr = document.querySelector('.avr-slot');
    if (story && avr && story.parentNode !== avr) avr.appendChild(story);
  }

  function run() { estimator(); collapse(); place(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  var tries = 0, t = setInterval(function () { run(); if (++tries > 40) clearInterval(t); }, 150);
  if (window.MutationObserver) {
    var mo = new MutationObserver(place);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 8000);
  }
})();